<!-- 理论测评平均得分详情 -->
<template>
  <div class="el-TheoryDetails">
    <el-row class="content_block">
      <TitleInfo title="理论测评平均得分详情" :titleImg="zjie"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-col :span="6">
          <el-row style="overflow: auto;border: 1px solid #DEDEDE;margin-right: 20px;min-height:400px;height: calc(100vh - 220px);padding: 20px;">
            <el-form ref="form" :model="search1" label-width="80px">
              <el-form-item label="选择班级">
                <el-select clearable v-model="search1.classId" style="width: 100%;" placeholder="请选择班级">
                  <template v-for="(item ,index) in classList">
                    <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-input placeholder="请输入学号或姓名" style="width: calc(100% - 96px)" prefix-icon="el-icon-search" v-model="search1.studentOrName"></el-input>
              <el-button type="primary" icon="el-icon-search" @click="getStu(page_stu = 1)">搜索</el-button>
            </el-form>
            <el-table
              :data="stuData"
              border
              @row-click="tableRowClick"
              style="width: 100%;margin-top: 10px;">
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentSn}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="sumScore" header-align="center" align="center" label="得分">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.sumScore}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;margin-top: 20px;">
              <el-pagination
                @size-change="handleSizeChange_stu"
                @current-change="handleCurrentChange_stu"
                :current-page.sync="page_stu"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit_stu"
                background
                small
                :pager-count="5"
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next"
                :total="total_stu">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
        <el-col :span="18">
          <el-row style="margin-bottom: 20px;">
            <label>项目名称：</label>
            <el-select v-model="handsOnId" placeholder="请选择班级">
              <template v-for="(item ,index) in practicalTrainingList">
                <el-option :label="item.handsOnName" :value="item.handsOnId"></el-option>
              </template>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="getInfo(1,page = 1)">搜索</el-button>
            <el-button type="primary" icon="el-icon-refresh" @click="refresh">清空</el-button>
            <el-button type="success" icon="el-icon-printer" @click="exportInfo">导出</el-button>
          </el-row>
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名" width="100"> </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号" width="100"> </el-table-column>
              <el-table-column prop="handsOnName" header-align="center" align="center" label="项目名称"> </el-table-column>
              <el-table-column prop="stem" header-align="center" align="center" label="题干">
                <template slot-scope="scope">
                  <el-row v-html="$getReplace(scope.row.stem)"></el-row>
                </template>
              </el-table-column>
              <el-table-column prop="questionType" header-align="center" align="center" label="题型" width="100">
                <template slot-scope="scope">
                  {{$retQuestionType(scope.row.questionType)}}
                </template>
              </el-table-column>
              <el-table-column prop="myOptions" header-align="center" align="center" label="我的选项" width="100">
                <template slot-scope="scope">
                  {{$isEmpty(scope.row.myOptions)?"":scope.row.myOptions}}
                </template>
              </el-table-column>
              <el-table-column prop="rightKey" header-align="center" align="center" label="正确答案" width="100"> </el-table-column>
              <el-table-column prop="theoryScore" header-align="center" align="center" label="得分" width="100"> </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import {getClassInfo,getHandsOnAchievementList,getPracticalTraining} from "@/common/getInfo";	//加载数据
export default {
  name: "TheoryDetails",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      zjie:require("../../images/course/zjie@2x.png"),
      search1:{
        classId:"",
        studentOrName:""
      },search:{
        handsOnId:this.$route.query.id
      },
      tableData:[],
      stuData:[],

      total: 0,
      limit:10,
      page:1,
      total_stu: 0,
      limit_stu:10,
      page_stu:1,
      classList:[],
      practicalTrainingList:[],
      seeStudentId:"",
      teacherOpenCourseId:this.$route.query.courseId,
      handsOnId:this.$route.query.id
    };
  },
  created() {
    getClassInfo({teacherOpenCourseId:this.teacherOpenCourseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    });
    getPracticalTraining({teacherOpenCourseId:this.teacherOpenCourseId}).then(ret =>{ //根据课程ID获取班级项目信息
      if(ret.code == 0){
        this.practicalTrainingList = ret.data;
      }
    });
    this.getInfo();
    this.getStu();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    handleSizeChange_stu(val) {
      console.log(`每页 ${val} 条`);
      this.limit_stu = val;
      this.getStu();
    },
    handleCurrentChange_stu(val) {
      console.log(`当前页: ${val}`);
      this.page_stu = val;
      this.getStu();
    },
    getInfo(tag){ //获取列表
      if(tag == 1){
        this.getStu();
      }
      let param = {
        limit:this.limit,
        page:this.page,
        studentId:this.seeStudentId,
        teacherOpenCourseId:this.teacherOpenCourseId,
        handsOnId:this.handsOnId
      }
      this.$post("/api/studentHandsOnTaskTheory/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getStu(){ //获取学生信息
      let param = {
        limit:this.limit_stu,
        page:this.page_stu,
        studentOrName:this.search1.studentOrName,
        classId:this.search1.classId,
        handsOnId:this.handsOnId,
        type:3,//type 1:视频 2:ppt 3:理论 4:实操 5:报告
      }
      this.param = Object.assign(param,this.search1);
      getHandsOnAchievementList(param).then((ret) => {
        this.total_stu = Number(ret.totalRow);
        this.stuData = ret.list;
      });
    },
    refresh(){
      this.page = 1;
      this.seeStudentId = "";
      this.getInfo();
    },
    exportInfo(){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downLoadFile('/jlw/studentHandsOnTaskTheory/excel/export.do?teacherOpenCourseId='+this.teacherOpenCourseId+"&studentId="+this.seeStudentId+"&handsOnId="+(!this.$isEmpty(this.search.handsOnId)?this.search.handsOnId:this.handsOnId), `PPT成绩-导出 ${new Date().toLocaleString()}.xlsx`);

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    tableRowClick(ow, column, cell, event){
      this.seeStudentId = ow.studentId;
      this.getInfo();
    }
  }
};
</script>
 <style  lang="less">
  .el-TheoryDetails{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/TheoryDetails.vue